
import './MobileMenu.css';
import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
//import Button from '@mui/material/Button';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu'; // You'll need @mui/icons-material


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; 
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';
import { faCartShopping, faMugHot, faCalendarCheck, faHouse } from '@fortawesome/free-solid-svg-icons';

function MenuMovil() {
  const [open, setOpen] = useState(false);
  let isLogin = false;
  let isVisible = false;
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      style={{ width: 250 }} // Adjust width as needed
    >
        <div style={{ display: "flex", justifyContent: "right", borderBottom: "2px solid #e2e8f0" }}>
            <IconButton onClick={toggleDrawer(false)} aria-label="Close menu" sx={{ color: 'white' }}>
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>
        </div>
      <ul className="menu-list-preview">
          <li><a href="/"><FontAwesomeIcon icon={faHouse} style={{ paddingRight: "10px" }}/>Home</a></li>
          {isLogin && <li><a href="#Subscripcion"><FontAwesomeIcon icon={faCircleUser} style={{ paddingRight: "10px" }}/>Profile</a></li>}
          {isVisible && <li><a href="#newsletter"><FontAwesomeIcon icon={faCalendarCheck} style={{ paddingRight: "10px" }}/>Membership</a></li>}
          <li><a href="/newsletter"><FontAwesomeIcon icon={faCalendarCheck} style={{ paddingRight: "10px" }}/>Newsletter</a></li>
          <li><a href="/specialtyCoffee"><FontAwesomeIcon icon={faMugHot} style={{ paddingRight: "10px" }}/>Specialty Coffee</a></li>
          <li><a href="/localfarms"><FontAwesomeIcon icon={faMugHot} style={{ paddingRight: "10px" }}/>Local Farms</a></li>
          <li><a href="/perfectCoffee"><FontAwesomeIcon icon={faMugHot} style={{ paddingRight: "10px" }}/>Find your Coffee</a></li>
          <li><a href="/customizeYourOrder"><FontAwesomeIcon icon={faMugHot} style={{ paddingRight: "10px" }}/>Customize Your Order</a></li>
          {isVisible && <li><a href="#Checkout"><FontAwesomeIcon icon={faCartShopping} style={{ paddingRight: "10px" }}/>Checkout</a></li>}
          {isVisible && <li><a href="/"><FontAwesomeIcon icon={faGlobe} style={{ paddingRight: "10px" }} />Languaje</a></li>}
      </ul>
    </div>
  );

  return (
    <>
      <div style={{height: "65px", backgroundColor: '#0C344B', width: `100%`, display: "flex", justifyContent: "space-between" }}>
        <a href='/'>
            <img src='./img/companyLogo.png' width="45" height="45" style={{ flex: "auto", maxHeight: "45px", maxWidth:"45px", padding: "10px" }}  alt=""/>
        </a>
        <div style={{ marginTop: "5px" }}>
            <IconButton
                edge="start"
                color=""
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ color: 'white' }} // Example styling for a menu icon
            >
                <MenuIcon sx={{ fontSize: '38px' }} />
            </IconButton>
            <Drawer
                anchor="right" // Can be 'left', 'right', 'top', or 'bottom'
                open={open}
                onClose={toggleDrawer(false)} 
                sx={{ '& .MuiPaper-root': {
                        backgroundColor: '#0C344B', color: "white" }}} >
                {DrawerList}
            </Drawer>
        </div>
        </div>
    </>
      
  );
}
export default MenuMovil;